import { Pie } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import './index.css';

interface DoughnutChartProps {
  id: number;
  data?: any;
}

let tooltipDiv = document.createElement('div');

let tooltipCount = 0;
const getOrCreateToolTip = (chart: any) => {
  let tooltipEl = chart.canvas.parentNode.querySelector(
    `.tooltipDesign-${tooltipCount}`,
  );
  if (!tooltipEl) {
    tooltipEl = document.createElement('DIV');
    tooltipEl.classList.add(`tooltipDesign-${tooltipCount}`);

    tooltipDiv.classList.add('tooltipDiv');
    tooltipEl.appendChild(tooltipDiv);
    chart.canvas.parentNode.appendChild(tooltipEl);
    // console.log('canvas', chart.canvas.parentNode);
  }
  tooltipCount++;
  return tooltipEl;
};

const externalFunc = (context: any) => {
  const { chart, tooltip } = context;
  // console.log('toolcontext', context);
  const tooltipEl = getOrCreateToolTip(chart);
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }
  if (tooltip.body) {
    const title = tooltip.title || [];
    const body = tooltip.body.map((b: any) => b.lines);
    const tooltipLi = document.createElement('div');

    title.forEach((title: any) => {
      tooltipDiv.appendChild(tooltipLi);

      const tooltipSpan = document.createElement('SPAN');
      tooltipLi.appendChild(tooltipSpan);

      const tooltipTitle = document.createTextNode(title);
      // console.log('insidetitle', tooltipTitle);
      tooltipSpan.appendChild(tooltipTitle);
    });
    // console.log('body', tooltip.body);
    const tooltipP = document.createElement('P');
    // body.foreach((body, i) => {
    const colors = tooltip.labelColors[0];
    const colorSquare = document.createElement('SPAN');
    colorSquare.classList.add('colorSquare');

    const textLabel = document.createTextNode(body);
    tooltipP.appendChild(colorSquare);
    tooltipP.appendChild(textLabel);

    const Ulnode = tooltipEl.querySelector('div');
    while (Ulnode.firstChild) {
      Ulnode.firstChild.remove();
    }
    Ulnode.appendChild(tooltipLi);
    tooltipLi.appendChild(tooltipP);
    tooltipEl.style.opacity = 1;

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding =
      tooltip.options.padding + 'px' + tooltip.options.padding + 'px';
    // console.log('tooltiptitle', tooltip.title);
    // console.log('tooltipbody', tooltip.body);
    // });
  }
};

export default function PieChartWidget({ id, data }: DoughnutChartProps) {
  const total = data.datasets[0].data.reduce(
    (a: number, b: number) => a + b,
    0,
  );

  const predefinedColors: Record<string, string> = {
    color1: '#FF5733',
    color2: '#33FF57',
    color3: '#3366FF',
    // Add more predefined colors here
  };

  const options: ChartOptions = {
    maintainAspectRatio: false,
    layout: {
      padding: 30,
    },
    elements: {
      arc: {
        hoverBorderWidth: 4,
        hoverBorderColor: (context) => {
          // Get the background color of the hovered arc
          const backgroundColor =
            data.datasets[0].backgroundColor?.[context.dataIndex];
          // Return the predefined hover border color if the background color is predefined
          return backgroundColor;
        },
      },
    },
    plugins: {
      tooltip: {
        // yAlign: 'bottom',
        enabled: false,
        // backgroundColor: '#fff',
        // borderWidth: 1,
        // borderColor: '#EAECF0',
        // titleColor: '#667085',
        // bodyColor: '#000',
        // displayColors: false,
        // callbacks: {
        //   //   label: (item) => {
        //   //     const percentage = ((item.parsed / total) * 100).toFixed(2);
        //   //     return `${item.label}`;
        //   //   },
        // },
        external: externalFunc,
      },
      legend: {
        position: 'right',
        labels: {
          usePointStyle: true,
          boxHeight: 8,
          boxWidth: 8,
          padding: 20,
          font: {
            size: 14,
            family: "'Figtree', sans-serif",
          },
          color: '#475467',
          //   generateLabels: (chart) => {
          //     const data = chart.data;
          //     if (data.labels && data.labels.length && data.datasets.length) {
          //       const {
          //         labels: { pointStyle },
          //       } = chart.legend!.options;
          //       const widgetData: any = data.datasets[0].data;

          //       // @ts-ignore
          //       return data.labels.map((label: string, i: number) => {
          //         const meta = chart.getDatasetMeta(0);
          //         const style = meta.controller.getStyle(i, false);

          //         return {
          //           text: `${widgetData[i]} ( ${Math.floor(
          //             (widgetData[i] / total) * 100,
          //           )}% ) - ${label}`,
          //           fillStyle: style.backgroundColor,
          //           strokeStyle: style.backgroundColor,
          //           lineWidth: style.borderWidth,
          //           //   pointStyle: 'rect',
          //           hidden: !chart.getDataVisibility(i),
          //           index: i,
          //         };
          //       });
          //     }
          //     return [];
          //   },
        },
      },
    },
  };

  return (
    <div className="pie-chart relative w-full">
      {/*@ts-ignore*/}
      <Pie data={data} options={options} id={id} />
    </div>
  );
}
